import TrashIcon from '@/shared/assets/icons/trash.svg?react'
import { BaseDialog } from '@/shared/components'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
  onSubmit: () => void
  nameDeletedItem?: string
}

export const DeleteDialog = ({
  modalVisible,
  setModalVisible,
  onSubmit,
  nameDeletedItem,
}: Props) => {
  const handleClose = () => {
    setModalVisible(false)
  }
  return (
    <BaseDialog
      isVisible={modalVisible}
      onClose={handleClose}
      onAction={onSubmit}
      actionButtonName="Удалить"
      actionButtonVariant="red"
      xButton={false}
      iconTitle={
        <div className="flex w-11 h-11 bg-canceled rounded-full items-center justify-center">
          <TrashIcon className="text-error" />
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        <h3 className="text-[20px]">{`Хотите удалить ${nameDeletedItem || ''}?`}</h3>
        <p className="text-text-secondary text-base">
          {`Действие необратимо, ${nameDeletedItem || ''} нельзя будет восстановить.`}
        </p>
      </div>
    </BaseDialog>
  )
}
